<template>
  <div class="hello" style="background-color: #fff; min-height: 100vh">
    <div style="padding: 20px 20px">
      <!-- 顶部图片 -->
      <van-image
        width="100%"
        radius="10px"
        :src="require('../assets/picture/cgk.png')"
      />
      <!-- 年份下拉表 -->
      <div>
        <van-row type="flex" justify="end">
          <van-col span="4">
            <select
              v-model="selectYear"
              @change="selectChange($event)"
              class="selectClass"
            >
              <option
                v-for="(item, index) in selectYearsColumns"
                :key="index"
                :value="item"
              >
                {{ item }}
              </option>
            </select>
          </van-col>
        </van-row>
      </div>
      <!-- 标题介绍 -->
      <h3 style="text-align: initial; color: #000">
        <span style="color: #d5a6cc">▋</span> {{ dataTitle }}
      </h3>

      <!-- 季度 -->
      <div class="cardClass quarterCls" style="flex-wrap: wrap">
        <div
          v-for="(item, i) in quarterList"
          :key="i"
          class="monthClass"
          @click="OpenDetail(item.value)"
        >
          {{ item.label }}
        </div>
      </div>
    </div>

    <!-- 表格图表弹窗 -->
    <van-dialog
      v-model="showZtjz"
      :showConfirmButton="false"
      style="width: 95%; height: calc(100% - 90px)"
    >
      <div class="vanDialogClass">
        <!-- 最顶部标题 -->
        <h3 style="text-align: initial; color: #000">
          <span style="color: #d5a6cc">▋</span> {{ dataTitle }}
        </h3>

        <!-- 表格 -->
        <div class="tableBoxClass">
          <div class="tableTitleClass">{{ tableConfigObj.title }}</div>
          <div class="tableCls">
            <header>
              <div>
                <span
                  v-for="(item, index) in tableConfigObj.columns"
                  :key="index"
                >
                  {{ item.text }}
                </span>
              </div>
            </header>
            <div
              style="
                height: 20px;
                color: darkgoldenrod;
                text-align: center;
                margin-top: 20px;
              "
              v-if="showZtjz && tableDataList.length == 0"
            >
              暂无数据
            </div>
            <div class="tableContentCls">
              <content>
                <div v-for="(item2, index2) in tableDataList" :key="index2">
                  <span
                    :style="{
                      backgroundColor:
                        item3.key == 'rank' ? item2.rankColor : '#fff',
                    }"
                    v-for="(item3, index3) in tableConfigObj.columns.filter(
                      (x) => x.key
                    )"
                    :key="index3 + '你好'"
                  >
                    {{ item2[item3.key] }}
                  </span>
                </div>
              </content>
              <!-- 备注 -->
              <div class="remarkBoxCls">
                <div><span style="color: #a1d3c0">▎</span> 备注：</div>
                <div class="remarkTextCls">
                  {{ remarkText }}
                </div>
                <div class="remarkColorCls flex">
                  <div>
                    <p style="background: #8d8d8d"></p>
                    <p>0%</p>
                  </div>
                  <div>
                    <p style="background: #a1d3c0"></p>
                    <p>前10%</p>
                  </div>
                  <div>
                    <p style="background: #69a6f7"></p>
                    <p>10%-25%</p>
                  </div>
                  <div>
                    <p style="background: #e8bc47"></p>
                    <p>25%-75%</p>
                  </div>
                  <div>
                    <p style="background: #e28337"></p>
                    <p>75%-90%</p>
                  </div>
                  <div>
                    <p style="background: #d82a2b"></p>
                    <p>后10%</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="closeBtnClass" @click="CloseDetail">关闭</div>
      </div>
    </van-dialog>
    <!-- 表格图表弹窗 -->
    <!-- 更改的新表格 -->
    <van-dialog
      v-model="showZtjzNew"
      :showConfirmButton="false"
      style="width: 95%; height: calc(100% - 90px)"
    >
      <div class="vanDialogClass">
        <!-- 最顶部标题 -->
        <h3 style="text-align: initial; color: #000">
          <span style="color: #d5a6cc">▋</span> {{ dataTitle }}
        </h3>

        <!-- 表格 -->
        <div class="tableBoxClass">
          <div class="tableTitleClass">{{ tableConfigObj.title }}</div>
          <div class="tableCls">
            <header>
              <div>
                <span
                  v-for="(item, index) in tableConfigObj.columnsNew"
                  :key="index"
                >
                  {{ item.text }}
                </span>
              </div>
            </header>
            <div
              style="
                height: 20px;
                color: darkgoldenrod;
                text-align: center;
                margin-top: 20px;
              "
              v-if="showZtjzNew && tableDataNewList.length == 0"
            >
              暂无数据
            </div>
            <div class="tableContentCls">
              <content>
                <div v-for="(item2, index2) in tableDataNewList" :key="index2">
                  <span
                    :style="{
                      backgroundColor:
                        item3.key == 'dept' ? item2.rankColor : '#fff',
                    }"
                    v-for="(item3, index3) in tableConfigObj.columnsNew.filter(
                      (x) => x.key
                    )"
                    :key="index3 + '你好'"
                  >
                    {{ item2[item3.key] }}
                  </span>
                </div>
              </content>
              <!-- 备注 -->
              <div class="remarkBoxCls">
                <div><span style="color: #a1d3c0">▎</span> 备注：</div>
                <div class="remarkTextCls">
                  {{ remarkTextNew }}
                </div>
                <div class="remarkColorCls flex">
                  <div>
                    <p style="background: #8d8d8d"></p>
                    <p>0%</p>
                  </div>
                  <div>
                    <p style="background: #a1d3c0"></p>
                    <p>前10%</p>
                  </div>
                  <div>
                    <p style="background: #69a6f7"></p>
                    <p>10%-25%</p>
                  </div>
                  <div>
                    <p style="background: #e8bc47"></p>
                    <p>25%-75%</p>
                  </div>
                  <div>
                    <p style="background: #e28337"></p>
                    <p>75%-90%</p>
                  </div>
                  <div>
                    <p style="background: #d82a2b"></p>
                    <p>后10%</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="closeBtnClass" @click="showZtjzNew = false">关闭</div>
      </div>
    </van-dialog>
    <div style="height: 100px"></div>
  </div>
</template>

<script>
import Table from './custom/Table.vue'
import { getDict } from '../api/zdqd.js'
import { ApiGetCGK } from '../api/zsyz'
import { getQuarterByDate } from '../utils/index'
export default {
  name: 'cgk',
  components: { Table },
  data() {
    return {
      // 后台获取的年份列表
      selectYearsColumns: [],
      // 获取今年
      // selectYear: new Date().getFullYear(),
      selectYear: process.env.VUE_SELECT_YEAR,
      currentQuarter: null,
      // 是否显示背景暂无数据
      showZtjz: false,
      // new
      showZtjzNew: false,
      // 顶部标题数据
      dataTitle: '北仑区"6+2"指标晾晒情况',
      // 备注文本
      remarkText: '',
      //new
      remarkTextNew: '',
      // 月份
      quarterList: [
        { label: '第一季度', value: 1 },
        { label: '第二季度', value: 2 },
        { label: '第三季度', value: 3 },
        { label: '第四季度', value: 4 },
      ],
      // 传给表格的数据
      tableConfigObj: {
        columns: [
          { text: '序号', key: 'sort' },
          { text: '指标名称', key: 'name' },
          { text: '责任部门', key: 'dept' },
          { text: '总量', key: 'total' },
          { text: '增速(占比)', key: 'speedUp' },
          { text: '排名(全市/全省)', key: 'rank' },
        ],
        columnsNew: [
          { text: '序号', key: 'sort' },
          { text: '指标名称', key: 'name' },
          { text: '总量', key: 'total' },
          { text: '全市排名', key: 'rank' },
          { text: '增速', key: 'speedUp' },
          { text: '全市排名', key: 'dept' },
        ],
        title: '',
      },
      // 传给表格的数据
      tableDataList: [
        {
          num: '1',
          name: '地区生产总值(GDP)增速(%)',
          dept: '区发改局',
          total: '327.5亿元',
          speed: '3.70%',
          ranking: '8/70',
          color: 'red',
        },
      ],
      // new传给表格的数据
      tableDataNewList1: [
        {
          sort: '1',
          name: 'GDP',
          total: '740.8',
          rank: '2',
          speedUp: '7.1%',
          dept: '1',
          rankColor: '#a1d3c0',
        },
        {
          sort: '2',
          name: '规上工业增加值',
          total: '/',
          rank: '/',
          speedUp: '11.6%',
          dept: '1',
          rankColor: '#69a6f7',
        },
        {
          sort: '3',
          name: '服务业增加值',
          total: '428.8',
          rank: '2',
          speedUp: '6.2%',
          dept: '4',
          rankColor: '#a1d3c0',
        },
        {
          sort: '4',
          name: '固定资产投资',
          total: '131.2',
          rank: '3',
          speedUp: '22.6%',
          dept: '1',
          rankColor: '#69a6f7',
        },
        {
          sort: '5',
          name: '社会消费品零售总额',
          total: '124',
          rank: '4',
          speedUp: '1.8%',
          dept: '6',
          rankColor: '#a1d3c0',
        },
        {
          sort: '5',
          name: '出口增速',
          total: '565.2',
          rank: '2',
          speedUp: '24.2%',
          dept: '1',
          rankColor: '#69a6f7',
        },
      ],
    }
  },
  created() {
    this.currentQuarter = getQuarterByDate()
    // 通过后台配置的字典，拿到年份
    getDict('selectyear_list').then((res) => {
      res.data.content.forEach((x) => {
        this.selectYearsColumns.push(x.label)
      })
    })
  },
  methods: {
    async init(selectYear, currentQuarter) {
      const res = await ApiGetCGK({
        year: selectYear,
        quarter: currentQuarter,
      })
      this.tableDataList = res.data.list
      this.remarkText = res.data.des
    },
    selectChange(e) {
      this.selectYear = e.target.value
    },

    async OpenDetail(value) {
      this.currentQuarter = value
      this.init(this.selectYear, this.currentQuarter)
      //老的判断显示
      // this.showZtjz = true
      //新的判断显示 判断是否为2025年1季度
      if (Number(this.selectYear) >= 2025) {
        if (this.currentQuarter == 1) {
          this.showZtjzNew = true
          this.tableDataNewList = this.tableDataNewList1
        } else {
          this.tableDataNewList = []
          this.showZtjzNew = true
        }
      } else {
        this.showZtjz = true
      }
      var Quarter = null

      switch (value) {
        case 1:
          Quarter = '一'
          break
        case 2:
          Quarter = '二'
          break
        case 3:
          Quarter = '三'
          break
        case 4:
          Quarter = '四'
          break
        default:
          break
      }
      this.tableConfigObj.title = `${this.selectYear}年${Quarter}季度`
    },
    CloseDetail() {
      this.showZtjz = false
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.monthClass {
  background-color: #d5a6cc;
  border-radius: 10px;
  width: 120px;
  height: 40px;
  text-align: center;
  line-height: 40px;
}
.quarterCls {
  padding: 20px;
}
.quarterCls div:nth-child(1),
.quarterCls div:nth-child(2) {
  margin-bottom: 20px;
}
.quarterCls div:nth-child(2),
.quarterCls div:nth-child(4) {
  margin-left: 30px;
}

.quarterCls div:nth-child(2) {
  background-color: #7bccd4;
}
.quarterCls div:nth-child(3) {
  background-color: #a1d3c0;
}
.quarterCls div:nth-child(4) {
  background-color: #71abdc;
}

.vanDialogClass {
  text-align: initial;
  padding: 25px 20px;
  height: 100%;
}
.conditionClass {
  width: 100%;
}
.conditionClass h4 {
  text-align: initial;
  color: #999;
}
.conditionClass > div {
  width: 100%;
  border: 2px solid #d4a6cb;
  padding: 20px;
  box-sizing: border-box;
  border-radius: 10px;
}
.conditionClass .conditionBox1 {
  background-color: #d4a6cb;
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 20px;
}
.conditionClass .conditionBox1 span {
  font-size: 30px;
  padding: 0 10px;
}
.conditionClass .conditionBox2 div {
  text-align: center;
}
.conditionClass .conditionBox2 div p:nth-child(1) {
  font-size: 24px;
  font-weight: 700;
}
.conditionClass .conditionBox2 div p:nth-child(2) {
  font-size: 14px;
  color: #999;
}
.closeBtnClass {
  position: absolute;
  bottom: 20px;
  left: 40px;
  width: 80%;
  height: 45px;
  line-height: 45px;
  background-color: #a1d3c0;
  text-align: center;
  border-radius: 30px;
  color: #fff;
  letter-spacing: 16px;
}

.selectClass {
  width: 100%;
  border-radius: 4px;
  border: 1px solid #c4c8cf;
  padding: 4px 0px 4px 0px;
}
.tableBoxClass {
  margin-top: 20px;
  color: #000;
  height: 100%;
}
.tableTitleClass {
  width: 100%;
  background-color: #e1f0ed;
  font-weight: 700;
  text-align: center;
  color: #000;
  border-radius: 10px 10px 0 0;
  padding: 5px 0;
}
.tableCls {
  font-size: 12px;
  font-weight: 700;
  height: 100%;
}
.tableContentCls {
  overflow: auto;
  height: calc(100% - 230px);
}
.tableBoxClass header div,
.tableBoxClass content div {
  width: 100%;
  display: flex;
}

.tableBoxClass header div span,
.tableBoxClass content div span {
  border: 1px solid #e3eef7;
  width: calc(100% / 6);
  word-wrap: break-word;
  word-break: break-all;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;
}
.tableBoxClass header div span:nth-child(1),
.tableBoxClass content div span:nth-child(1) {
  width: 30px;
}

.remarkBoxCls {
  margin-top: 20px;
  color: #000;
}
.remarkTextCls {
  font-size: 12px;
  margin: 10px 0;
}
.remarkColorCls {
  width: 100%;
}
.remarkColorCls > div {
  width: calc(100% / 6);
  text-align: center;
  font-size: 12px;
}
.remarkColorCls > div p:nth-child(1) {
  height: 10px;
  border: 1px solid #ffffff;
}
.remarkColorCls > div p:nth-child(2) {
  font-size: 10px;
}
.van-dialog >>> .van-dialog__content {
  height: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/cgk.vue